<template>
  <div class="bodymain">
    <div class="title">
      <span class="titlefront">询问管理 /</span>
      笔录详情
    </div>
    <div class="headermain">
      <span class="headerleft">{{form.recordPO.caseName}}</span>
      <div>
        <el-button type="primary" @click="previewbtn">
          <i class="el-icon-printer"></i>
          预览
        </el-button>
        <el-button type="primary" @click="back">返回</el-button>
        <el-button type="primary" @click="endrecord"> <i class="el-icon-s-release"></i>结束</el-button>
      </div>
    </div>

    <div class="bodycontainer">
      <el-row>
        <el-col :span="10">
          <div class="grid-content bg-purple bodyleft">
            <div class="bodyleftheader">
              <span class="contenttitle">笔录基本信息</span>
            </div>
            <div class="contline">
              <span class="contentkey">案件名称：</span>
              <!-- <el-input disabled v-model="form.recordPO.caseName" placeholder="请输入案件名称"></el-input> -->
              {{ form.recordPO.caseName }}
            </div>
            <div class="contline">
              <span class="contentkey">询问场景：</span>
              {{form.recordPO.inquiryScene}}
            </div>
            <div class="contline">
              <span class="contentkey">案发单位：</span>
              <!-- <el-input disabled v-model="form.recordPO.happenPlace" placeholder="请输入案发单位"></el-input> -->
              {{ form.recordPO.happenPlace }}
            </div>
            <div class="contline">
              <span class="contentkey">询问地点：</span>
              <!-- <el-input disabled v-model="form.recordPO.inquiryPlace" placeholder="请输入询问地点"></el-input> -->
              {{ form.recordPO.inquiryPlace }}
            </div>
            <div class="contline">
              <span class="contentkey">开始时间：</span>
              {{form.recordPO.inquiryBegin}}
            </div>
            <div class="contline">
              <span class="contentkey">结束时间：</span>
              {{form.recordPO.inquiryEnd||"未结束"}}
            </div>
            <div class="bodyleftheader">
              <span class="contenttitle">被询问人信息</span>
            </div>
            <div class="contline">
              <span class="titlewidths">
                姓名：
              </span>
              <!-- <el-input disabled v-model="form.recordPO.respondentName" placeholder="姓名" style="width:100px;margin-right:10px;height:40px"></el-input> -->
              {{ form.recordPO.respondentName }}
              <span class="titlewidthr">
                年龄：
              </span>
              <!-- <el-input disabled v-model="form.recordPO.respondentAge" style="width:100px;margin-right:10px;height:40px" placeholder="年龄"></el-input> -->
              {{ form.recordPO.respondentAge }}
            </div>
            <div class="contline">
              <span class="titlewidths">
                民族：
              </span>
              <!-- <el-input disabled v-model="form.recordPO.respondentNation" placeholder="民族" style="width:100px;margin-right:10px;height:40px"></el-input> -->
              {{ form.recordPO.respondentNation }}
              <span class="titlewidthr">
                性别：
              </span>
              <!-- <el-radio v-model="form.recordPO.respondentGender" label="男">男</el-radio>
              <el-radio v-model="form.recordPO.respondentGender" label="女">女</el-radio> -->
              {{ form.recordPO.respondentGender }}
              <!-- <el-input
                v-model="form.recordPO.respondentGender"
                placeholder="性别"
                style="width:100px;margin-right:10px;height:40px"
              ></el-input>-->
            </div>
            <div class="contline">
              <span class="titlewidths">职业：</span>
              <!-- <el-input v-model="form.recordPO.respondentOccupation" placeholder="职业" style="width:100px;margin-right:10px;height:40px"></el-input> -->
              {{ form.recordPO.respondentOccupation }}
              <span class="titlewidthr">
                文化程度：
              </span>
              <!-- <el-select placeholder="请选择文化程度" style="width:130px;margin-right:10px;height:40px" v-model="form.recordPO.respondentEdu">
                <el-option v-for="item in edulist" :key="item.eduName" :label="item.eduName" :value="item.eduName"></el-option>
              </el-select> -->
              {{ form.recordPO.respondentEdu }}
            </div>
            <div class="contline">
              <span class="titlewidths">
                询问次数：
              </span>
              <!-- <el-select placeholder="请选择询问次数" style="width:100px;margin-right:10px;height:40px" v-model="form.recordPO.respondTimes">
                <el-option v-for="item in numlist" :key="item.num" :label="item.num" :value="item.num"></el-option>
              </el-select> -->
              {{ form.recordPO.respondTimes }}
              <span class="titlewidthr">
                被询问人类型：
              </span>
              <!-- <el-select placeholder="请选择被询问人类型" style="width:130px;margin-right:10px;height:40px" v-model="form.recordPO.respondentType">
                <el-option v-for="item in peoplelist" :key="item.peopletype" :label="item.peopletype" :value="item.peopletype"></el-option>
              </el-select> -->
              {{ form.recordPO.respondentType }}
            </div>
            <div class="contline">
              <span class="titlewidth">手机号：</span>
              <!-- <el-input v-model="form.recordPO.respondentPhone" placeholder="请输入手机号"></el-input> -->
              {{ form.recordPO.respondentPhone }}
            </div>
            <div class="contline">
              <span class="titlewidth">
                证件类型：
              </span>
              <!-- <el-select placeholder="请选择证件类型" v-model="form.recordPO.respondentCertType" style="width:100%">
                <el-option v-for="item in cardlist" :key="item.cardtype" :label="item.cardtype" :value="item.cardtype"></el-option>
              </el-select> -->
              {{ form.recordPO.respondentCertType }}
            </div>
            <div class="contline">
              <span class="titlewidth">
                证件号：
              </span>
              <!-- <el-input v-model="form.recordPO.respondentCertNo" placeholder="请输入证件号"></el-input> -->
              {{ form.recordPO.respondentCertNo }}
            </div>
            <div class="contline">
              <span class="titlewidth">
                户籍地：
              </span>
              <!-- <el-input v-model="form.recordPO.respondentOrigin" placeholder="请输入户籍地"></el-input> -->
              {{ form.recordPO.respondentOrigin }}
            </div>
            <div class="contline">
              <span class="titlewidth">现居地：</span>
              <!-- <el-input v-model="form.recordPO.respondentAddress" placeholder="请输入现居地"></el-input> -->
              {{ form.recordPO.respondentAddress }}
            </div>
            <div class="contline">
              <span class="titlewidth">工作单位：</span>
              <!-- <el-input v-model="form.recordPO.respondentWorkUnit" placeholder="请输入工作单位"></el-input> -->
              {{ form.recordPO.respondentWorkUnit }}
            </div>

            <div class="bodyleftheader">
              <span class="contenttitle">询问人信息</span>
            </div>
            <div class="askcontainer" v-if="datalist.mainInquirer">
              <div class="askmain">
                <div class="askheader">主办询问人</div>
                <div class="askline">姓名：{{datalist.mainInquirer.nickname}}</div>
                <div class="askline">执法证号：{{datalist.mainInquirer.certNo}}</div>
                <div class="askline">手机号：{{datalist.mainInquirer.phone}}</div>
              </div>
              <div class="askmain" v-if="datalist.auxiliaryInquirer">
                <div class="askheader">辅办询问人</div>
                <div class="askline">姓名：{{datalist.auxiliaryInquirer.nickname}}</div>
                <div class="askline">执法证号：{{datalist.auxiliaryInquirer.certNo}}</div>
                <div class="askline">手机号：{{datalist.auxiliaryInquirer.phone}}</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="grid-content bg-purple-light bodyright">
            <div class="askcontentmain">
              <el-form :model="askForm" hide-required-asterisk>
                <div v-for="(item, index) in askForm.askList" :key="index">
                  <div class="askqueline">
                    <el-form-item :prop="'askList.' + index + '.content'" :rules="{
                      required: true, message: '不能为空', trigger: 'blur',
                    }">
                      <template slot="label">
                        <span class="asktype">问</span>
                      </template>
                      <el-input v-model="item.content" disabled placeholder="问" style="font-size:18px" />
                    </el-form-item>
                  </div>
                  <div class="askqueline">
                    <el-form-item :prop="'askList.' + index + '.answer'" :rules="{
                      required: true, message: '不能为空', trigger: 'blur',
                    }">
                      <template slot="label">
                        <span class="quetype">答</span>
                      </template>
                      <el-input disabled type="textarea" v-model="item.answer" placeholder="答" style="font-size:18px" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { findrecord, setFinishrecord, sendsms, previewpdf } from "../axios/api.js";

export default {
  data () {
    return {
      value1: "",
      value2: "",
      menuname: "",
      datalist: "",
      currentTime: 0,
      edulist: [
        {
          id: 1,
          eduName: "小学及以下"
        },
        {
          id: 2,
          eduName: "中学"
        },
        {
          id: 3,
          eduName: "大专"
        },
        {
          id: 4,
          eduName: "本科"
        },
        {
          id: 5,
          eduName: "研究生及以上"
        }
      ],
      cardlist: [
        {
          id: 1,
          cardtype: "身份证"
        },
        {
          id: 2,
          cardtype: "驾驶证"
        },
        {
          id: 3,
          cardtype: "护照"
        },
        {
          id: 4,
          cardtype: "台胞证"
        }
      ],
      numlist: [
        {
          id: 1,
          num: 1
        },
        {
          id: 2,
          num: 2
        },
        {
          id: 3,
          num: 3
        },
        {
          id: 4,
          num: 4
        },
        {
          id: 5,
          num: 5
        }
      ],

      peoplelist: [
        {
          id: 1,
          peopletype: "受委托人"
        },
        {
          id: 2,
          peopletype: "违法嫌疑人"
        },
        {
          id: 3,
          peopletype: "证人"
        },
        {
          id: 4,
          peopletype: "受害者"
        }
      ],

      timeObj: null, // 时间对象,下方会用到
      myHours: "00", // 我定义来接收计算出来的 小时 的
      myMinutes: "00", // 我定义来接收计算出来的 分钟 的
      mySeconds: "00", // 我定义来接收计算出来的 秒钟 的
      askForm: {
        askList: [
          {
            content: "你是否申请办案人员回避？",
            answer: "不申请回避。",
            sort: 0
          },
          {
            content:
              "你医院于2022年2月21日因诊疗活动超出登记范围等违法行为给予行政处罚，在此之后你医院是否开展私处漂红、私处脱毛、PRP等医疗美容项目？",
            answer:
              "被行政处罚过之后没有开展私处漂红、PRP等医美项目，不单独开展私处脱毛项目，但是手术备皮是用仪器无痛脱毛备皮。",
            sort: 1
          },
          {
            content: "1111",
            answer: "222",
            sort: 2
          }
        ]
      },
      form: {
        questions: [
          {
            answer: "",
            content: "",
            createTime: "",
            id: 0,
            recordId: 0,
            sort: 0,
            updateTime: ""
          }
        ],
        recordPO: {
          auxiliaryInquirerId: "",
          caseName: "",
          caseTypeId: "",
          createTime: "",
          deptId: "",
          happenPlace: "",
          id: 0,
          inquiryBegin: "",
          inquiryEnd: "",
          inquiryPlace: "",
          inquiryScene: "",
          mainInquirerId: "",
          respondTimes: 0,
          respondentAddress: "",
          respondentAge: 0,
          respondentCertNo: "",
          respondentCertType: "",
          respondentEdu: "",
          respondentGender: "",
          respondentName: "",
          respondentNation: "",
          respondentOccupation: "",
          respondentOrigin: "",
          respondentPhone: "",
          respondentType: "",
          respondentWorkUnit: "",
          updateTime: "",
        }
      }
    };
  },
  methods: {
    testTimer () {
      this.timeFunction();
      setInterval(() => {
        this.timeFunction();
      }, 1000);
    },

    //发送短信签名
    sendcode () {
      const params = {
        link: decodeURIComponent(
          `https://record.terabits.cn/pdf?caseid=${localStorage.getItem(
            "caseid"
          )}，`
        ),
        phone: this.form.recordPO.respondentPhone,
        recordId: localStorage.getItem(
          "caseid"
        ),
        type:'sign'
      };
      if (this.form.recordPO.respondentPhone) {
        sendsms(params).then(res => {
          if (res && res.code === 200) {
            console.log(111);
            this.$message.success("链接发送成功");
          }
        });
      } else {
        this.$message.error("请输入被询问人手机号码");
      }
    },

    //点击返回
    back () {
      // window.location.href = "/askmanage";
      this.$router.go(-1)
    },

    //点击预览
    previewbtn () {
      previewpdf([localStorage.getItem("caseid")]).then(res => {
        if (res && res.code === 200) {
          window.open("https://videoapi.terabits.cn" + res.data);
        }
      });
    },

    //点击结束
    endrecord () {
      this.form.recordPO.status = 2;
      this.form.recordPO.inquiryEnd = this.$moment(new Date()).format(
        "yyyy-MM-DD HH:mm:ss"
      );
      this.$confirm("您确定要结束该案件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: action => {
          if (action === "confirm") {
            this.finishrecord();
          }
        }
      });
    },
    finishrecord () {
      setFinishrecord(localStorage.getItem("caseid"), this.form).then(res => {
        // console.log(this.form.recordPO.status);
        if (res && res.code === 200) {
          this.$message.success("该笔录结束");
          // this.$router.go(0)
          // if (this.form.recordPO.status === 2) {
            window.location.href = "/record/ask";
          // }
          // if (this.flag === true) {
          //   previewpdf([localStorage.getItem("caseid")]).then(res => {
          //     if (res && res.code === 200) {
          //       window.open("https://ivatest.terabits.cn" + res.data);
          //       this.flag = false;
          //     }
          //   });
          // }
        }
      })
    },

    //点击删除
    deletebutton (item) {
      this.$confirm("确认要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(item);
          console.log(item.id);
          console.log(this.askForm.askList);
          var arr = [];
          for (var i in this.askForm.askList) {
            if (this.askForm.askList[i].id !== item.id) {
              arr.push(this.askForm.askList[i]);
            }
          }
          console.log(arr);
          this.form.questions = arr;
          this.askForm.askList = arr;
        })
        .catch(() => { });
    },
    //点击新增
    addbutton (item) {
      console.log(item);
      console.log(item.sort);
      console.log(this.askForm.askList);
      for (var i in this.askForm.askList) {
        if (this.askForm.askList[i].sort > item.sort) {
          this.askForm.askList[i].sort = this.askForm.askList[i].sort + 1;
        }
      }
      this.askForm.askList.push({
        content: "",
        answer: "",
        sort: item.sort + 1
      });

      this.askForm.askList.sort(function (a, b) {
        return a.sort < b.sort ? -1 : 1;
      });

      console.log(this.askForm.askList);
    },
    recordlist () {
      findrecord([localStorage.getItem("caseid")]).then(res => {
        console.log(res.data);
        if (res && res.code === 200) {
          // console.log(111);
          // console.log(res.data.recordPO.inquiryScene);
          this.form = res.data;
          this.form.recordPO.inquiryBegin
            ? this.form.recordPO.inquiryBegin
            : this.$moment(new Date()).format("yyyy-MM-DD HH:mm:ss");
          this.askForm.askList = res.data.questions.sort(function (a, b) {
            return a.sort < b.sort ? -1 : 1;
          });
          this.datalist = res.data;

          // console.log(this.tableData);
        }
      });
    }
  },
  mounted () {
    // 拖拽后触发的事件
    this.$dragging.$on("dragged", res => {
      console.log(res);
    });
  },
  created () {
    this.recordlist();
  }
};
</script>

<style scoped  >
.deletebtn {
  background: white;
  border: 1px solid #ff405c;
  color: #ff405c;
}

.deletebtn:hover {
  background: #ff405c;
  border: 1px solid #ff405c;
  color: white;
}

.deletebtn:focus {
  background: #ff405c;
  border: 1px solid #ff405c;
  color: white;
}

.addbtn {
  background: white;
  border: 1px solid #3370ff;
  color: #3370ff;
}

.askqueline {
  margin-top: 10px;
  display: flex;
  align-items: center;
  padding-right: 20px;
  box-sizing: border-box;
}

.askqueline .el-form-item {
  flex: 1;
  display: flex;
  align-items: center;
}

::v-deep .askqueline .el-form-item .el-form-item__content {
  flex: 1;
  margin-right: 20px;
}

.asktype {
  width: 30px;
  height: 30px;
  color: white;
  background: #ffa700;
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  margin-right: 10px;
}

.quetype {
  width: 30px;
  height: 30px;
  color: white;
  background: #00bea5;
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  margin-right: 10px;
}

.drag-content {
  width: 100%;
  text-align: left;
}
/* .drag-content span {
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  display: inline-block;
} */

.videomain {
  border-bottom: 1px solid #3370ff;
  height: 350px;
  /* position: absolute;
  left: 20px;
  top: 20px; */
}
.qarecord {
  font-size: 18px;
  font-weight: bold;
  color: #222426;
  text-align: left;
  display: flex;
  align-items: center;
  /* position: absolute;
  left: 20px;
  top: 20px; */
}

.tip {
  height: 43px;
  background: #fdebca;
  border-radius: 5px;
  display: inline-block;
  color: #ffa700;
  font-size: 16px;
  display: flex;
  align-items: center;
  width: 80px;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  justify-content: space-around;
  font-weight: bold;
  margin-left: 20px;
}

.tipimg {
  width: 20px;
  height: 20px;
}

.askcontainer {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 20px;
  margin-bottom: 20px;
}

.askmain {
  border: 1px solid #e8e8e8;
  width: 200px;
  font-size: 14px;
  text-align: left;
}

.askheader {
  height: 36px;
  display: flex;
  align-items: center;
  padding-left: 12px;
  font-size: 14px;
  border-bottom: 1px solid #e8e8e8;
}

.askline {
  line-height: 36px;
  padding-left: 12px;
}
.titlewidths {
  display: inline-block;
  width: 100px;
  text-align: right;
}
.titlewidthr {
  display: inline-block;
  width: 130px;
  text-align: right;
}

.titlewidth {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.dian {
  color: #ff405c;
  vertical-align: sub;
  margin-right: 5px;
}
.contentkey {
  font-size: 16px;
  color: #666666;
  width: 100px;
  display: inline-block;
}
.timeimg {
  width: 32px;
  height: 32px;
  margin-right: 10px;
}

.headermid {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  color: #3370ff;
}

.titlefront {
  font-weight: normal;
  font-size: 14px;
}

.headermain {
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 8px 0px rgba(202, 202, 202, 0.3);
  border-radius: 3px;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 30px;
  padding-right: 30px;
  margin-top: 20px;
  box-sizing: border-box;
}

.headerleft {
  font-size: 18px;
  color: #222426;
  font-weight: bold;
}

.bodycontainer {
  margin-top: 20px;
}

.bodyleft {
  height: 700px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 8px 0px rgba(202, 202, 202, 0.3);
  border-radius: 3px;
  overflow-y: scroll;
}

.bodyright {
  margin-left: 20px;
  height: 700px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 8px 0px rgba(202, 202, 202, 0.3);
  border-radius: 3px;
}

.askcontenthead {
  height: 370px;
  padding: 20px;
  padding-bottom: 0;
}

.askcontentmain {
  padding-left: 20px;
  height: 690px;
  overflow-y: scroll;
}

.bodyleftheader {
  height: 60px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #cacaca;
  padding-left: 20px;
}

.contenttitle {
  color: #3370ff;
  font-size: 18px;
  font-weight: bold;
  height: 58px;
  display: inline-block;
  line-height: 60px;
  border-bottom: 3px solid #3370ff;
}

.contline {
  margin-top: 20px;
  padding-left: 20px;
  text-align: left;
  display: flex;
  align-items: center;
  flex: 1;
  padding-right: 20px;
  box-sizing: border-box;
}
</style>
